var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBaggageSmGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H10V1C10 0.45 9.55 0 9 0H5C4.45 0 4 0.45 4 1V4H2C0.9 4 0 4.9 0 6V17C0 18.1 0.9 19 2 19C2 19.55 2.45 20 3 20C3.55 20 4 19.55 4 19H10C10 19.55 10.45 20 11 20C11.55 20 12 19.55 12 19C13.1 19 14 18.1 14 17V6C14 4.9 13.1 4 12 4ZM4.5 16H3V7H4.5V16ZM7.75 16H6.25V7H7.75V16ZM8.5 4H5.5V1.5H8.5V4ZM11 16H9.5V7H11V16Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaggageSmGrey);
export default __webpack_public_path__ + "static/media/icon-baggage-sm-grey.e8f804eb00a70ad4a235c92c7542af58.svg";
export { ForwardRef as ReactComponent };